<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<div class="wrapper">

  <!-- Selector de sitio → almacén + indicadores + cambio de vista.
       Aquí el selector SÍ es del toolbar (showScope queda en su valor por
       omisión): esta pantalla se construyó de cero y no arrastra un
       formulario previo, a diferencia de equipo y productos. -->
  <app-inventory-toolbar
    [places]="placeList"
    [warehouses]="warehouseList"
    [kpis]="kpis"
    [activeKpi]="activeKpi"
    [viewMode]="viewMode"
    storageKey="instrumentals"
    [showViewToggle]="false"
    (scopeChange)="onScopeChange($event)"
    (kpiToggle)="onKpiToggle($event)"
    (viewModeChange)="onViewModeChange($event)">
  </app-inventory-toolbar>

  @if (scopeReady) {

    <div class="filter-bar filter-bar--flush">
      <div class="filter-card">
        <app-search-pill placeholder="Serie, RFID, código…" (search)="applyTextFilter($event)"></app-search-pill>
        <span class="filter-card__meta">Mostrando: <b>{{ dataSource.filteredData.length }}</b></span>
        <span class="filter-card__spacer"></span>
        <mat-button-toggle-group class="view-toggle" [value]="viewMode" (change)="onViewModeChange($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
          <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
          <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <app-filter-chips [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="instrumentales"></app-filter-chips>
    </div>

    <div class="list-actions">
      <button mat-stroked-button (click)="pageLoad.refresh(search())"><mat-icon>refresh</mat-icon> Actualizar</button>
    </div>

    <app-selection-bar [count]="selection.selected.length" (export)="exportSelection()" (clear)="selection.clear()"></app-selection-bar>

    <mat-paginator [pageSizeOptions]="[25, 50, 100]"></mat-paginator>


    <!-- ── Vista de tarjetas ─────────────────────────────────────── -->
    @if (viewMode === 'cards') {
      <div class="inv-cards cat-cards">
        @for (item of dataSource.filteredData; track item.id) {
          <div class="cat-card" [class.cat-card--selected]="selection.isSelected(item)">
            <div class="cat-card__photo">
              @if (item._image) {<img [src]="item._image" alt="Foto" loading="lazy" (click)="openImage(item._image)">} @else {<mat-icon>image_not_supported</mat-icon>}
            </div>
            <div class="cat-card__head">
              <mat-checkbox color="primary" [checked]="selection.isSelected(item)" (change)="selection.toggle(item)" matTooltip="Seleccionar"></mat-checkbox>
              <span class="cat-card__title">{{ item._code }}</span>
              <span class="inv-status" [attr.data-status]="item.status">{{ item.status || '—' }}</span>
            </div>
            <div class="cat-card__body">
                <div class="cat-card__field"><span class="cat-card__label">Descripción:</span><span class="cat-card__value">{{ item._description || '—' }}</span></div>
                <div class="cat-card__field"><span class="cat-card__label">Serie:</span><span class="cat-card__value">{{ item.serialNumber || '—' }}</span></div>
                <div class="cat-card__field"><span class="cat-card__label">RFID:</span><span class="cat-card__value">{{ item.tagRfid || '—' }}</span></div>
                <div class="cat-card__field"><span class="cat-card__label">Año:</span><span class="cat-card__value">{{ item.manufacturerYear || '—' }}</span></div>
                <div class="cat-card__field"><span class="cat-card__label">Usos:</span><span class="cat-card__value">{{ item.numberUses ?? 0 }}</span></div>
                <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ item.type || '—' }}</span></div>
            </div>
          </div>
        }
        @if (dataSource.filteredData.length === 0) {
          <p class="inv-cards__empty">
            No hay instrumental que coincida con el filtro.
          </p>
        }
      </div>
    }

    <!-- ── Vista de tabla ────────────────────────────────────────── -->
    <div class="table-container mat-elevation-z8" [hidden]="viewMode !== 'table'">
      <table mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="select-cell">
            <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()" [indeterminate]="isPartiallySelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="select-cell">
            <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="photo">
          <th mat-header-cell *matHeaderCellDef class="photo-cell"> Foto </th>
          <td mat-cell *matCellDef="let e" class="photo-cell">
            <span class="inv-thumb">@if (e._image) {<img [src]="e._image" alt="Foto" loading="lazy" (click)="openImage(e._image)">} @else {<mat-icon>image_not_supported</mat-icon>}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="instrumental">
          <th mat-header-cell *matHeaderCellDef> Código </th>
          <td mat-cell *matCellDef="let e"> {{ e._code }} </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Descripción </th>
          <td mat-cell *matCellDef="let e"> {{ e._description }} </td>
        </ng-container>

        <ng-container matColumnDef="serialNumber">
          <th mat-header-cell *matHeaderCellDef> Serie </th>
          <td mat-cell *matCellDef="let e"> {{ e.serialNumber || '—' }} </td>
        </ng-container>

        <ng-container matColumnDef="tagRfid">
          <th mat-header-cell *matHeaderCellDef> Etiqueta RFID </th>
          <td mat-cell *matCellDef="let e"> {{ e.tagRfid || '—' }} </td>
        </ng-container>

        <ng-container matColumnDef="manufacturerYear">
          <th mat-header-cell *matHeaderCellDef> Año </th>
          <td mat-cell *matCellDef="let e"> {{ e.manufacturerYear || '—' }} </td>
        </ng-container>

        <ng-container matColumnDef="numberUses">
          <th mat-header-cell *matHeaderCellDef> Usos </th>
          <td mat-cell *matCellDef="let e"> {{ e.numberUses ?? 0 }} </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Tipo </th>
          <td mat-cell *matCellDef="let e"> {{ e.type || '—' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Estado </th>
          <td mat-cell *matCellDef="let e">
            <span class="chip-status" [attr.data-status]="e.status">
              {{ e.status || '—' }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (dataSource.filteredData.length === 0) {
        <p class="table-empty">
          Este locker no tiene instrumental que coincida con el filtro.
        </p>
      }
    </div>

  }
</div>
